import React, { useContext } from "react";
import {
  lightClient1,
  lightClient10,
  lightClient2,
  lightClient3,
  lightClient4,
  lightClient5,
  lightClient6,
  lightClient7,
  lightClient8,
  lightClient9,
  darkClient1,
  darkClient2,
  darkClient4,
  darkClient5,
  darkClient7,
  darkClient8,
  darkClient9,
  darkClient10,
  darkClient3,
  darkClient6,
} from "../../assets/images/index";
import Marquee from "react-fast-marquee";
import { AuthContext } from "../../context/AuthContext";

const lightClient: string[] = [
  lightClient1,
  lightClient2,
  lightClient3,
  lightClient4,
  lightClient5,
  lightClient6,
  lightClient7,
  lightClient8,
  lightClient9,
  lightClient10,
];

const darkClient: string[] = [
  darkClient1,
  darkClient2,
  darkClient3,
  darkClient4,
  darkClient5,
  darkClient6,
  darkClient7,
  darkClient8,
  darkClient9,
  darkClient10,
];

const Clients = () => {
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`${
        theme === "dark" ? "border-black bg-white" : "border-white bg-black"
      } py-5 sm:py-0 border-y-[1px]  border-opacity-10`}
    >
      <div className="mx-auto max-w-screen-2xl w-full flex justify-center items-center">
        <Marquee
          speed={50}
          pauseOnHover
          autoFill
        >
          {theme === "dark" &&
            darkClient.map((item, index) => (
              <div
                className="flex justify-center mx-6 flex-shrink-0"
                key={index}
              >
                <img
                  className="w-40 h-40 object-contain rounded-lg"
                  src={item}
                  alt={`Client ${index + 1}`}
                />
              </div>
            ))}
          {theme === "light" &&
            lightClient.map((item, index) => (
              <div
                className="flex justify-center mx-6 flex-shrink-0"
                key={index}
              >
                <img
                  className="w-40 h-40 object-contain rounded-lg"
                  src={item}
                  alt={`Client ${index + 1}`}
                />
              </div>
            ))}
        </Marquee>
      </div>
    </div>
  );
};

export default Clients;
